var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbowLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rainbow-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pages-V1",
    transform: "translate(-22.000000, -17.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(23.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rainbow-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#323B45",
    x: 1.5936,
    y: 1.5392,
    width: 32.768,
    height: 32.768
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#1DE9B6",
    x: 25.3376,
    y: 0.0288,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#01B6F5",
    x: 12.672,
    y: 0.0288,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FE4849",
    x: 0.0992,
    y: 0.0288,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F4F6F9",
    x: 25.2672,
    y: 12.5952,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFCC00",
    x: 12.6048,
    y: 12.5952,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#F8752D",
    x: 0.0288,
    y: 12.5952,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#01B6F5",
    x: 25.2672,
    y: 25.1584,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#EA4243",
    x: 12.6048,
    y: 25.1584,
    width: 10.656,
    height: 10.656,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#1AD1A3",
    x: 0.0288,
    y: 25.1584,
    width: 10.656,
    height: 10.656,
    rx: 2
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowLogo);
export default __webpack_public_path__ + "static/media/rainbow-logo.0fce475205377759497fcc7e2c01791d.svg";
export { ForwardRef as ReactComponent };